var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  rx: 16,
  fill: "#454545"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 7.2H8.498A1.3 1.3 0 0 0 7.2 8.5V23.5a1.3 1.3 0 0 0 1.3 1.3H23.5a1.3 1.3 0 0 0 1.3-1.3V8.499A1.3 1.3 0 0 0 23.5 7.2ZM12.445 22.193H9.799v-8.405h2.646v8.405Zm-1.325-9.57a1.52 1.52 0 1 1 1.528-1.518 1.498 1.498 0 0 1-1.528 1.518Zm11.078 9.578h-2.645v-4.592c0-1.355-.575-1.773-1.318-1.773-.785 0-1.555.592-1.555 1.807V22.2h-2.646v-8.407h2.545v1.165h.034c.255-.517 1.15-1.4 2.515-1.4 1.477 0 3.072.876 3.072 3.442l-.002 5.2Z",
  fill: "#FAF8F6"
})));
export default SvgLinkedin;